import { useContext, useEffect, useState } from 'react'
import { Typography } from '@mui/material'
import Grid from '@mui/material/Unstable_Grid2/Grid2'

import OneTextArea from '../../Components/OneTextArea/OneTextArea'
import OneModal from '../OneModal/OneModal'
// import telefone from '../../Assets/icones/telefone-comercial.svg'
// import telefoneCelular from '../../Assets/icones/telefone-celular.svg'
// import telegram from '../../Assets/icones/telegram.svg'
import { WebSocketContext } from '../../Providers/WebSocket/WebSocketContext'
import { CondominiosContext } from "../../Providers/CondominiosContext/CondominiosContext"
import { tipoCondominio } from '../../Utils/optionsSelects'
import { Info } from '@mui/icons-material'

const container1 = {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    gap: '10px '
}
const formGroupTextValue = {
    fontWeight: 'bold'

}
const textAreaSx = {
    height: '400px',
    width: '100%'
}
const Area = {
    display: 'flex',
    flexDirection: 'column'
}

const CondominioInfo = ({ setOpenInfoCondominio, openInfoCondominio }) => {
    const { addRoute, sendWs } = useContext(WebSocketContext)
    const { activeCond } = useContext(CondominiosContext)
    const [dados, setDados] = useState([])
    const [condominio, setCondominio] = useState('')

    const getDados = (msg) => {
        const tipo_cond = msg.data.condominio.tipo_condominio
        let result = tipoCondominio.filter(tipo => tipo.value == tipo_cond)[0]
        setCondominio(result.descricao)
        setDados(msg.data.condominio)
    }
    addRoute('buscarCondominio', getDados)
    useEffect(() => {
        sendWs("buscarCondominio", { id: activeCond.id })
    }, [])
    return (
        <OneModal
            open={openInfoCondominio}
            setOpen={setOpenInfoCondominio}
            titleText="Informações"
            TitleIcon={ Info }
            maxWidth='md'
            fullWidth={true}
        >
            <Grid sx={container1}>
                <Grid container xs={12}>
                    <Grid xs={2.3} >
                        <Typography>Nome: </Typography>
                    </Grid>
                    <Grid xs={9.7}>
                        <Typography sx={formGroupTextValue}>{dados.nome}</Typography>
                    </Grid>
                </Grid>
                <Grid container xs={12}>
                    <Grid xs={2.3}>
                        <Typography>Endereço: </Typography>
                    </Grid>
                    <Grid xs={9.7}>
                        <Typography sx={formGroupTextValue}>{dados.endereco}</Typography>
                    </Grid>
                </Grid>
                <Grid container xs={12} >
                    <Grid xs={2.3}>
                        <Typography>Tipo: </Typography>
                    </Grid>
                    <Grid xs={9.7}>
                        <Typography sx={formGroupTextValue}>{condominio}</Typography>
                    </Grid>
                </Grid>
                {/* <Grid container xs={12}>
                    <Grid xs={4.8}>
                        <Typography>Administrador/Sindico: </Typography>
                    </Grid>
                    <Grid xs={3.2}>
                        <Typography sx={formGroupTextValue}>administrador</Typography>
                    </Grid>
                    <Grid xs={4}>
                        <img
                            style={{
                                height: '20px',
                                width: '21px'
                            }}
                            title="Abrir Telefone  Comercial"
                            src={telefone}
                            // onClick={() => setOpenInfoCondominio(!openInfoCondominio)}
                        />
                        <img
                            style={{
                                height: '20px',
                                width: '21px'
                            }}
                            title="Abrir Telefone  Comercial"
                            src={telefoneCelular}
                            // onClick={() => setOpenInfoCondominio(!openInfoCondominio)}
                        />
                        <img
                            style={{
                                height: '20px',
                                width: '21px'
                            }}
                            title="Abrir Telefone  Comercial"
                            src={telegram}
                            // onClick={() => setOpenInfoCondominio(!openInfoCondominio)}
                        />
                    </Grid>
                </Grid> */}
                <Grid>
                    <Grid sx={Area}>
                        <Typography>Observações: </Typography>
                        <OneTextArea
                            name="observacoes"
                            defaultValue={dados.obs}
                            readOnly={true}
                            // onChange={handleChange}
                            newSx={textAreaSx}
                        />
                    </Grid>
                </Grid>
            </Grid>
        </OneModal>
    )
}

export default CondominioInfo
